// Perder um negócio pergunta o MOTIVO — como fazem os CRMs de referência.
//
// O campo `motivo_perda` existe desde sempre e a tela nunca perguntou: "Perder"
// gravava o status direto. Medido em 01/10/2026, dos 100 negócios perdidos 22
// estão sem motivo e 69 carregam um código do Ploomes ("LossReasonId=110239662")
// que não diz nada a ninguém. Sem motivo não há como responder "por que
// perdemos?", que é a pergunta que um funil existe para responder.
//
// Não é regra nova: preenche o campo que já existe, pela mesma rota.
import { useState } from 'react';
import { Modal, Radio, Input, Typography, Space } from 'antd';

export const MOTIVOS_DE_PERDA = [
  'Preço acima do orçamento do cliente',
  'Perdemos para um concorrente',
  'Cliente adiou ou cancelou o projeto',
  'Sem retorno do cliente',
  'Prazo não atendia',
  'Escopo fora do que fazemos',
  'Outro motivo',
];

/** Limite da coluna `motivo_perda` (varchar 300). */
const TETO = 300;

/** Junta motivo e detalhe no texto que vai para o campo, respeitando o teto. */
export function textoDoMotivo(motivo: string, detalhe: string): string {
  const d = String(detalhe || '').trim();
  const base = motivo === 'Outro motivo' && d ? d : (d ? `${motivo} — ${d}` : motivo);
  return base.slice(0, TETO);
}

export function ModalPerder({ titulo, onCancelar, onConfirmar }: {
  titulo: string;
  onCancelar: () => void;
  onConfirmar: (motivo: string) => Promise<void> | void;
}) {
  const [motivo, setMotivo] = useState('');
  const [detalhe, setDetalhe] = useState('');
  const [salvando, setSalvando] = useState(false);
  const precisaDetalhe = motivo === 'Outro motivo' && !detalhe.trim();

  return (
    <Modal open title="Marcar o negócio como perdido" okText="Marcar como perdido" cancelText="Voltar"
      okButtonProps={{ danger: true, disabled: !motivo || precisaDetalhe, loading: salvando }}
      onCancel={onCancelar}
      onOk={async () => {
        setSalvando(true);
        try { await onConfirmar(textoDoMotivo(motivo, detalhe)); } finally { setSalvando(false); }
      }}
      width="min(94vw, 520px)">
      <Typography.Paragraph style={{ marginBottom: 12 }}>
        <b>{titulo}</b>
        <br />
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          Por que perdemos? A resposta fica no negócio e é o que permite, depois, saber onde o funil vaza.
        </Typography.Text>
      </Typography.Paragraph>
      <Radio.Group value={motivo} onChange={e => setMotivo(e.target.value)} style={{ width: '100%' }}>
        <Space direction="vertical" size={6}>
          {MOTIVOS_DE_PERDA.map(m => <Radio key={m} value={m}>{m}</Radio>)}
        </Space>
      </Radio.Group>
      <Input.TextArea value={detalhe} onChange={e => setDetalhe(e.target.value)}
        placeholder={motivo === 'Outro motivo' ? 'Qual foi o motivo?' : 'Detalhe (opcional): concorrente, valor, o que o cliente disse…'}
        autoSize={{ minRows: 2, maxRows: 4 }} maxLength={TETO - 60} showCount
        style={{ marginTop: 14 }} />
    </Modal>
  );
}
